// @flow
import { takeLatest, select, call, put } from 'redux-saga/effects';
import { AppActionTypes } from 'actions';
import { errorLogger, infoLogger } from '../helpers';
import persistStore from 'store/serializer';
import api from 'api';
import ActionTypes, {
  setMsisdn,
  isCustomerType,
  fetchApplicationcontentComplete,
  loadingAction,
  errorMessage,
  setToggles,
} from '../actions/app.actions';
import indexTogglesByKey from '../helpers/createToggleLookup';
import getCustomerTypeContentKey from '../helpers/customerTypeHelpers';
import contentJson from '../assets/content/content.json';

function* init() {}

function* persist() {
  const state = yield select();
  persistStore(state);
}

function* errorMessages(response) {
  yield put(errorMessage(response.message));
}

function* fetchContent() {
  try {
    yield errorMessage('');
    yield put(loadingAction(true));

    const content = contentJson;

    if (content) {
      yield put(fetchApplicationcontentComplete(content.data ? content.data : content));
      yield put(loadingAction(false));
    }
  } catch (err) {
    errorLogger({ name: 'client-fetch-content', log: `Fetch content failed: ${err.message}` });
    yield call(errorMessages(err));
  }
}

function* fetchCustomerType(data) {
  try {
    const response = yield call(api.getCustomerTypes, data);

    if (!response.data) {
      errorLogger({ name: 'client-fetch-customer-type', log: `Fetching customer type failed` });
      throw 'Error fetching customer data';
    }
    const { customerType } = response.data;
    window.__CUSTOMER_TYPE__ = customerType;
    infoLogger({ name: 'client-fetch-customer-type', log: 'Get customer type succeeded' });

    yield put(setMsisdn(data.msisdn));
    // yield put(setEid(eid));
    const customerTypeContentKey = getCustomerTypeContentKey(customerType);
    yield put(isCustomerType({ customerType, customerTypeContentKey }));
    yield errorMessage(null);
  } catch (error) {
    errorLogger({ name: 'client-fetch-customer-type', log: `Fetch customer type saga failed: ${error.message}` });
    yield call(errorMessages(error));
  }
}

function* fetchToggles() {
  const response = yield call(api.getToggles);

  if (!response.data) {
    errorLogger({ name: 'client-fetch-toggles', log: `Fetch toggles failed` });
    throw 'Error fetching toggles';
  }
  infoLogger({ name: 'client-fetch-toggles', log: 'Fetch toggles succeeded' });
  const togglesAsKeyValues = indexTogglesByKey(response.data.toggles);
  yield put(setToggles(response.data.toggles, togglesAsKeyValues));
}

export default [
  takeLatest(ActionTypes.FETCH_TOGGLES, fetchToggles),
  takeLatest(ActionTypes.FETCH_APP_CONTENT_START, fetchContent),
  takeLatest(ActionTypes.FETCH_CUSTOMER_TYPE, fetchCustomerType),
  takeLatest(AppActionTypes.INIT, init),
  takeLatest(AppActionTypes.PERSIST_STORE, persist),
];
